import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import axios from "axios";
import data from "../../assets/apiRoutes.json";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import { GridLayout } from "../../common/GridLayout";
import TextBox from 'devextreme-react/text-box';
import TextArea from 'devextreme-react/text-area';
import "./wmmodulestyle.css";
import {
  Column,
  DataGrid,
  GroupPanel,
  Grouping,
  FilterRow,
  FilterPanel,
  Sorting,
  Paging,
  Pager,
  LoadPanel,
  Export,
  ColumnHeaderFilter,
  Summary,
  TotalItem,
  ColumnChooser,
  StateStoring
} from "devextreme-react/data-grid";
import { GetDateTimeStandardFormat } from "../../common/Utils";
import ItemGrid from "./transactions/inventory/ItemGrid";

const TransactionSerialNumberManifest = (props) => {
  const dataBase =
    props.ReceiptReducer.wmTransactionDatabase !== ""
      ? props.ReceiptReducer.wmTransactionDatabase
      : "";
  const [popupState, setPopUpState] = useState(props.visibility);
  const [serialNumberData, setSerialNumberData] = useState([]);
  
  const [transactionSerialNumberObj, setTransactionSerialNumberObj] = useState({
    dbName: dataBase,
    Rowid: props.transRowid,
  });
  const [transactionObj, setTransactionObj] = useState({
    consigneeAddress1: "",
    consigneeName: "",
    consigneeCity: "",
    consigneeState: "",
    consigneeZip: "",
    customerName: "",
    customerAddress_1: "",
    customerCity: "",
    customerState: "",
    customerZIP: "",
    shipperName: "",
    shipperAddress1: "",
    shipperCity: "",
    shipperState: "",
    shipperZip: "",
    transactionnumber:"",
    actualreceivedshippeddatetime:"",
    reference:"",
    shipperbolnumber:"",
    carriername:"",
    container:"",
    equipmentinterchangereport:"",
  });

  var accessToken = props.oidc.user.access_token;
  
  var customerData = transactionObj.customerName == null ? '' : transactionObj.customerName + '\n';
  customerData += transactionObj.customerAddress_1 == null ? '' : transactionObj.customerAddress_1.trim();
  customerData += transactionObj.customerCity == null ? '' : ' ' + transactionObj.customerCity + '\n';
  customerData += transactionObj.customerState == null ? '' : ' ' + transactionObj.customerState.trim();
  customerData += transactionObj.customerZIP == null ? '' : ' ' + transactionObj.customerZIP;
  var shipperData = transactionObj.shipperName == null ? '' : transactionObj.shipperName + '\n';
  shipperData += transactionObj.shipperAddress1 == null ? '' : transactionObj.shipperAddress1.trim();
  shipperData += transactionObj.shipperCity == null ? '' : ' ' + transactionObj.shipperCity + '\n';
  shipperData += transactionObj.shipperState == null ? '' : ' ' + transactionObj.shipperState.trim();
  shipperData += transactionObj.shipperZip == null ? '' : ' ' + transactionObj.shipperZip;
  var consigneeData = transactionObj.consigneeName == null ? '' : transactionObj.consigneeName + '\n';
  consigneeData += transactionObj.consigneeAddress1 == null ? '' : transactionObj.consigneeAddress1.trim();
  consigneeData += transactionObj.consigneeCity == null ? '' : ' ' + transactionObj.consigneeCity + '\n';
  consigneeData += transactionObj.consigneeState == null ? '' : ' ' + transactionObj.consigneeState.trim();
  consigneeData += transactionObj.consigneeZip == null ? '' : ' ' + transactionObj.consigneeZip;


  const hideInfo = () => {
    setPopUpState(false);
    props.parentCallback(false);
  };

  useEffect(() => {
    loadInventorySerialNumberData();
    loadInventoryTransactionData();
  }, []);
  const loadInventorySerialNumberData = () => {
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Serialnumber.GetSerialNumberManifest}`,
        transactionSerialNumberObj,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((res) => {
        setTransactionSerialNumberObj(res.data);
      });
  };
  const loadInventoryTransactionData = () => {
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.GetTransactionData}`,
        transactionSerialNumberObj,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((res) => {
        var transData = res.data;
        setTransactionObj(transData);
      });
  };
  function customizeData(data) {
    return `Total: ` + data.value;
  }
  function customizeTotal(data) {
    return data.value;
  }

  const gridKey = "688f05ba-1590-4446-8429-43bfb325f36b";
  const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken); }, []);
  const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state); }, []);

  return (
    <Popup
      visible={popupState}
      onHiding={hideInfo}
      dragEnabled={false}
      hideOnOutsideClick={true}
      showCloseButton={true}
      showTitle={true}
      title="Serial Number Manifest"
      //container=".inventory-container"
      container="#root"
      width="80vw"
      height="90vh"
      fullScreen={false}
    >
      <div className="popup-content" style={{maxHeight: '100%' }}>
        <div className="row">
          <div className="col-md-3" >
            <TextBox
              label="Transaction #"
              name="transactionnumber"
              value={transactionObj.transactionnumber}
              stylingMode='outlined'
              labelMode="static"
              readOnly={true}
            />
          </div>
          <div className="col-md-3">
            <TextBox
              label="Recv/ShipDT"
              name="Recv/ShipDT"
              value={transactionObj.actualreceivedshippeddatetime ? GetDateTimeStandardFormat(transactionObj.actualreceivedshippeddatetime) : ""}
              stylingMode='outlined'
              labelMode="static"
              readOnly={true}
            />
          </div>
          <div className="col-md-3">
            <TextBox
              label="Reference"
              name="Reference"
              value={transactionObj.reference}
              stylingMode='outlined'
              labelMode="static"
              readOnly={true}
            />
          </div>
          <div className="col-md-3">
            <TextBox
              label="Shipper BOL #"
              name="ShipperBOL"
              value={transactionObj.shipperbolnumber}
              stylingMode='outlined'
              labelMode="static"
              readOnly={true}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 topMargin">
            <TextBox
              label="Carrier Name"
              name="CarrierName"
              value={transactionObj.carriername}
              stylingMode='outlined'
              labelMode="static"
              readOnly={true}
            />
          </div>
          <div className="col-md-3 topMargin">
            <TextBox
              label="Container #"
              name="ContainerNumber"
              value={transactionObj.container}
              stylingMode='outlined'
              labelMode="static"
              readOnly={true}
            />
          </div>
          <div className="col-md-3 topMargin">
            <TextBox
              label="Equip Interchange Report"
              name="EquipInterchangeReport"
              value={transactionObj.equipmentinterchangereport}
              stylingMode='outlined'
              labelMode="static"
              readOnly={true}
            />
          </div>

        </div>
        <div className="row topMargin">
          <div className="col-md-3 topMargin">
            <TextArea
              stylingMode='outlined'
              labelMode="static"
              label="Customer"
              autoResizeEnabled={false}
              height={120}
              value={customerData}
              readOnly={true}
            />
          </div>
          <div className="col-md-3 topMargin">
            <TextArea
              stylingMode='outlined'
              labelMode="static"
              label="Shipper"
              autoResizeEnabled={false}
              height={120}
              value={shipperData}
              readOnly={true}
            />
          </div>
          <div className="col-md-3 topMargin">
            <TextArea
              stylingMode='outlined'
              labelMode="static"
              label="Consignee"
              autoResizeEnabled={false}
              height={120}
              value={consigneeData}
              readOnly={true}
            />
          </div>
        </div>

        {/* Serial Number Grid */}
          <div className="row">
          <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
            noDataText={transactionSerialNumberObj.length > 0 ? "" : "No Data"}
            dataSource={transactionSerialNumberObj}
            showBorders={true}
            className="customDataTableDesign"
            hoverStateEnabled={true}
            allowColumnResizing={true}
            allowColumnReordering={true}
            height={450}
          >
            <ColumnChooser enabled={true} />
            <Export enabled={true} allowExportSelectedData={true} text="Export" />
            <ColumnHeaderFilter />
            <Sorting visible={true} mode="multiple" />
            <LoadPanel enabled={true} />
            <Paging defaultPageSize={10} />
            <Pager
              visible={true}
              showPageSizeSelector={true}
              allowedPageSizes={[5, 10, 20, "all"]}
              showNavigationButtons={true}
            />
            <FilterRow visible={true} />
            <FilterPanel visible={true} />
            <GroupPanel visible={true} />
            <Grouping autoExpandAll={false} />
            <StateStoring
              enabled={true}
              type="custom"
              customLoad={loadState}
              storageKey={gridKey}
              customSave={saveState}
            />
            <Column dataField="serialNumberCode" caption="Serial #"></Column>
            <Column dataField="itemSNGrossWeight" caption="Gross Weight"></Column>
            <Column
              dataField="itemSNOriginalGrossWeight"
              caption="Original Gross Weight"
            ></Column>
            <Column dataField="itemSNNetWeight" caption="Net Weight"></Column>
            <Column
              dataField="itemSNOriginalNetWeight"
              caption="Original Net Weight"
            ></Column>
            <Column dataField="itemSNSize_1" caption="Size 1"></Column>
            <Summary>
              <TotalItem
                column="serialNumberCode"
                summaryType="count"
                customizeText={customizeTotal}
              />
              <TotalItem
                column="itemSNGrossWeight"
                summaryType="sum"
                customizeText={customizeData}
              />
              <TotalItem
                column="itemSNOriginalGrossWeight"
                summaryType="sum"
                customizeText={customizeTotal}
              />
              <TotalItem
                column="itemSNNetWeight"
                summaryType="sum"
                customizeText={customizeTotal}
              />
              <TotalItem
                column="itemSNOriginalNetWeight"
                summaryType="sum"
                customizeText={customizeTotal}
              />
              <TotalItem
                column="itemSNSize_1"
                summaryType="sum"
                customizeText={customizeTotal}
              />
            </Summary>
          </DataGrid>
        </div>
      </div>
    </Popup>
  );
};

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(TransactionSerialNumberManifest);
